module.exports = __webpack_public_path__ + "pin-green.725a3dde8ccdf5755e84.svg";


//////////////////
// WEBPACK FOOTER
// C:/WORK/Projects/ActNow_NG2/src/styles/assets/pin-green.svg
// module id = ../../../../../src/styles/assets/pin-green.svg
// module chunks = styles